<template>
  <div id="oauth-page">
    <!-- 新加 start -->
    <!-- 发送手机验证码弹窗 -->
    <van-popup
      v-model="showApplyLogin"
      round
      position="bottom"
      closeable
      :style="{ height: '58%' }"
      get-container="body"
      @close="closePop"
    >
      <div class="loginContent" style="margin: 16px 0px 20px">
        <div class="content" style="padding: 10px 20px 20px">
          <div
            class="title titleStyleAll"
            style="
              font-weight: 600;
              text-align: center;
              margin-bottom: 28px;
              font-size: 18px;
            "
          > 注册账号
          </div>
          <van-cell-group>
            <van-field
              v-model="regMoblie"
              center
              clearable
              type="number"
              maxlength="11"
              placeholder="请输入11位手机号码"
              @blur="checkMobile"
              :error-message="errMsg.mobilePhone"
            />
            <van-field
              v-model="regCode"
              center
              clearable
              type="number"
              maxlength="6"
              placeholder="请输入短信验证码"
              @blur="changeCode"
              :error-message="errMsg.code"
            >
              <template #button>
                <van-button
                  :disabled="disabled"
                  size="small"
                  type="info"
                  style="
                    background-color: #ccc;
                    color: #fff;
                  "
                  @click="sendcode()"
                  >{{ btntxt }}</van-button
                >
              </template>
            </van-field>
          </van-cell-group>
          <div style="margin-top: 30px" @click="sureMobile">
            <van-button block type="info" style="border-radius: 30px"
              >确定</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 新加 end -->
    <!-- 新加 start -->
    <van-popup v-model="showLoginForm" position="bottom" :style="{ height: '100%' }" >
      <LoginForm :regMoblie="regMoblie" :regCode="regCode" :toLabel="1" :agentCode="agentCode" @closeLoginForm="closeLoginForm"></LoginForm>
    </van-popup>
    <!-- 新加 end -->
  </div>
</template>

<script>
import LoginForm from "@/components/common/loginForm/index.vue";
import { getSMSFrom } from "@/utils/lib/tools";
import { searchToObj } from "@/utils/lib/searchtoobj.js";
import TripleDES from "@/utils/lib/crypto.js";
import { loginDialogToMall, commonDialog, commonToast } from "@/utils/lib/toast.js";

export default {
  data() {
    return {
      showApplyLogin: false,
      regMoblie: "", // 申请试用弹框 手机号码
      regCode: "", // 申请试用弹框 验证码
      errMsg: {
        mobilePhone: "", // 手机号码
        code: "", // 验证码
      },
      pattern: /^1[3456789]\d{9}$/, // 手机号码验证
      btntxt: "发送验证码",
      disabled: false, // 禁用发送验证码按钮
      time: 0, // 倒计时
      showLoginForm: false, // 展示登录信息表格
      agentCode: ""
    };
  },
  components: {
    LoginForm
  },
  computed: {
    userId () {
      return this.$store.state.user.userId;
    },
    userguid () {
      return this.$store.state.user.userGuid;
    },
    isWX: {
      get () {
        return Number(localStorage.getItem("WX_VERSION"));
      },
      set () { },
    },
    accountstatus () {
      return this.$store.state.user.accountstatus;
    },
  },
  created () {
    if(this.$route.query.agentcode) {
      this.agentCode = this.$route.query.agentcode
    } else {
      this.agentCode = ""
    }
    // 扫描运营商二维码进入
    if (this.$route.query.agentcode) {
      console.log("扫描运营商二维码进入123");
      sessionStorage.clear();
      this.$cookie.delete("cookieObj");
      this.templogin();
      return;
    }

    if (location.search.includes("docid")) {
      this.sharelogin();
      return;
    }
    if (
     sessionStorage.getItem("userId") == '' ||
      this.$cookie.get("cookieObj") == null ||
      this.$cookie.get("cookieObjByWx") == null
    ) {
      this.wxLogin();
      console.log('oauth2===>')
    } else {
      if (this.accountstatus == 300 || this.accountstatus == 400) {
        this.$router.push("/");
      } else {
        this.$router.replace("/newFiles");
      }
    }
  },
  methods: {
    
    closePop () {
      this.$router.push("/index");
    },
    
    // 发送验证码
    sendcode() {
      // 发送验证码接口参数
      let getSmsCodeReqObj = {
        mobilenum: this.regMoblie,
        reqsrc: 1,
      }
      this.$http.reqSmsCode(getSmsCodeReqObj).then((response) => {
        if (response.rtncode === 1) {
          if (response.rltcode === 1) {
            commonDialog("验证码发送成功", this);
            this.time = 60;
            this.disabled = true;
            this.timer();
          } else {
            commonDialog(response.rltdesc, this);
          }
        } else {
          commonDialog(response.rtndesc, this);
        }
      })
    },
    
    // 子组件关闭
    closeLoginForm() {
      this.showLoginForm = false
    },
    // 确定提交手机号
    sureMobile () {
      // this.showLoginForm = true
      this.checkMobile()
      this.changeCode()
      this.$http
        .reqRegCheckSmsCode(
          this.regMoblie,
          this.regCode,
          getSMSFrom.SMS_CODE_TYPE_REG
        )
        .then((resp) => {
          if (resp.rtncode === 1) {
            if (resp.rltcode === 1) {
              this.showLoginForm = true
            } else {
              commonDialog(resp.rltdesc, this)
            }
          } else {
            commonDialog(resp.rtndesc, this)
          }
        })
    },
    // 验证码的倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    // 验证手机号码
    checkMobile() {
      if (!this.regMoblie) {
        this.errMsg.mobilePhone = "请输入手机号码";
        return false;
      } else if (!this.pattern.test(this.regMoblie)) {
        this.errMsg.mobilePhone = "手机号码输入有误，请重新输入";
        return false;
      } else {
        this.errMsg.mobilePhone = "";
        return true;
      }
    },
    // 验证申请试用验证码
    changeCode() {
      if (!this.regCode) {
        this.errMsg.code = "请输入验证码";
        return false;
      } else {
        this.errMsg.code = "";
        return true;
      }
    },
    // 临时登录
    templogin () {
      this.$http.reqTempLogin().then((resp) => {
        if (resp.rtncode === 1) {
          if (resp.rltcode === 1) {
            if (
              resp.accounttype === 0 &&
             sessionStorage.getItem("userId") === null &&
              this.$cookie.get("cookieObj") === null
            ) {
              this.$store.commit("user/setUserId", resp.userid);
              this.$store.commit("user/setUserGuid", resp.userguid);
              this.$store.commit("user/setRealName", resp.realname);
              this.$store.commit("user/setToken", resp.token);
              this.$store.commit("user/setMobileNum", resp.mobilenum);
              this.$store.commit("user/setAccountType", resp.accounttype);
              this.$store.commit("user/setPermission", resp.permission);
              this.$store.commit("user/setAccountStatus", resp.accountstatus);
              this.$store.commit("user/setShowMsg", resp.showmsg)
              this.$store.commit("user/setMaxOpenNum", resp.maxopendocnum)
              this.$store.commit("user/setOpenNum", resp.opendocnum)
              this.$store.commit("user/setMaxToken", resp.maxtokens)
              this.$store.commit("user/setMallVer", resp.mallver)

              if (resp.permission != null && resp.permission.length > 0) {
                let items = [];
                resp.permission.forEach((item) => {
                  items.push(item.f);
                });
                this.$store.commit("user/setPermissionArray", items);
              }

              localStorage.setItem("userguid", resp.userguid);
              sessionStorage.setItem("token", resp.token);

              //判断是运营商登录
              if (this.$route.query.logintype === undefined) {
                this.wxLogin();
                return;
              }
              // 判断是申请试用
              if (this.$route.query.logintype === "tryuse") {
                this.tryUseReg();
                return;
              }
              // 判断是立即购买
              if (this.$route.query.logintype === "gotobuy") {
                this.goToBuy();
                return;
              }
            }
          }
        }
      });
    },
    // 微信登录按钮
    wxLogin () {
      if (location.search.includes("code")) {
        console.log("微信登录回调的参数", location.search);
        let obj = searchToObj(location.search);
        
        let tmpGuid = localStorage.getItem("userguid")
        //console.log('TMP', tmpGuid.indexOf("TMP"));
        if(tmpGuid.indexOf("TMP") == -1) {
          obj.tempuserguid = '';
        } else {
          obj.tempuserguid = localStorage.getItem("userguid");
        }
        let newObj = {
          code: obj.code,
          state: obj.state,
          tempuserguid: obj.tempuserguid,
        };

        sessionStorage.setItem("wxPromiseObj", JSON.stringify(newObj));
        
        this.$http
          .reqPostWeixinLogin(newObj)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                
                if (this.$route.query.agentcode !== undefined) {
                  this.hasRegLogin(res);
                  return;
                }

                
                this.bus.$emit("saveTokenHandle", res, 1);

                // 保存微信登录的token和userguid
                let cookieObjByWx = {
                  userguid: res.userguid,
                  token: res.token,
                };
                this.checkUserInfo(res);
                console.log("cookieObjByWx", cookieObjByWx);
                let data = TripleDES.encode("token", cookieObjByWx);
                this.$cookie.set("cookieObjByWx", JSON.stringify(data), 4);
              } else if (res.rltcode === -3) {
                localStorage.setItem("scanStatus", false)
                //console.log('qwe--------')
                if (this.$route.query.agentcode !== undefined) {
                  // 代理商进的没有注册过
                  this.$router.push(
                    `/agentgoto?agentcode=${this.$route.query.agentcode}`
                  );
                  return;
                } else {
                  //新加 start
                  this.showApplyLogin = true
                }
                // 如果返回-3，询问是否注册
                // this.$dialog
                //   .confirm({
                //     message: "系统检测到您尚未注册账号，是否注册？",
                //     confirmButtonText: "是",
                //     cancelButtonText: "否",
                //   })
                //   .then(() => {
                //     // 去注册
                //     this.$http
                //       .reqPostWeixinRegLogin(obj)
                //       .then((resp) => {
                //         console.log("微信注册成功====>", resp);
                //         console.log(resp);
                //         this.bus.$emit("saveTokenHandle", resp, 1);
                //         console.log(
                //           "sessionStorage.getItem()",
                //          sessionStorage.getItem("userId")
                //         );
                //         this.$router.push("/newFiles");
                //       })
                //       .catch((err) => {
                //         console.log("微信注册======>", err);
                //       });
                //   })
                //   .catch((err) => {
                //     console.log("微信注册======>", err);
                //     this.$router.push("/newFiles");
                //   });
              } else {
                commonDialog(res.rltdesc, this, "确认", () => {
                  this.$router.push("/index");
                });
              }
            } else {
              commonDialog(res.rtndesc, this, "确认", () => {
                this.$router.push("/index");
              });
            }
          })
          .catch((err) => {
            console.log("微信登录=====>", err);
          });
      }
    },
    // 注册过登录
    hasRegLogin (res) {
      this.bus.$emit("saveTokenHandle", res, 1);
      // 微信扫描运营商二维码登录
      if(localStorage.getItem("scanStatus") && this.$cookie.get("cookieObjByWx") == null) {
        this.$router.push("/index");
        commonToast('您已经注册过账号!', this);
      } else if (!localStorage.getItem("scanStatus")) {
        this.$router.replace(
        `/onlineMall?agentcode=${this.$route.query.agentcode}`
        );
      } else {
        this.$dialog.confirm({
          title: '提示',
          message: '您已经注册过账号!',
          confirmButtonText: '政策法规'
        }).then(() => {
          this.$router.push("/newFiles");
        }).catch(() => {
          this.$router.push("/index");
        })
        // this.$router.push("/newFiles");
        // commonToast('您已经注册过账号!', this);
      }
      
    },
    // 判断登录信息
    checkUserInfo (res) {
      localStorage.setItem("scanStatus", true)
      // 如果有弹框信息按钮
      if (res.accountstatus == 100) {
        // 试用期
        if (res.showmallbutton && res.showmsg !== "") {
          loginDialogToMall(
            res.showmsg,
            this.$store.state.user.permissionArray,
            this
          );
        } else if (!res.showmallbutton && res.showmsg !== "") {
          commonDialog(res.showmsg, this, "确认", () => {
            this.$router.push("/newFiles");
          });
        } else {
          this.$router.push("/newFiles");
        }
      } else if (res.accountstatus == 107) {
        if (res.showmallbutton && res.showmsg !== "") {
          // 试用期到期7天内
          loginDialogToMall(
            res.showmsg,
            this.$store.state.user.permissionArray,
            this
          );
        } else if (!res.showmallbutton && res.showmsg !== "") {
          commonDialog(res.showmsg, "确认", this, () => {
            this.$router.push("/newFiles");
          });
        } else {
          this.$router.push("/newFiles");
        }
      } else if (res.accountstatus == 207) {
        if (res.showmallbutton && res.showmsg !== "") {
          // 正常使用到期7天内
          loginDialogToMall(
            res.showmsg,
            this.$store.state.user.permissionArray,
            this
          );
        } else if (!res.showmallbutton && res.showmsg !== "") {
          commonDialog(res.showmsg, this, "确认", () => {
            this.$router.push("/newFiles");
          });
        } else {
          this.$router.push("/newFiles");
        }
      } else if (res.accountstatus == 300) {
        if (res.showmallbutton && res.showmsg !== "") {
          // 试用期满进入冻结期
          this.onlyGoMall(res);
        } else if (!res.showmallbutton && res.showmsg !== "") {
          commonDialog(res.showmsg, this, "确认", () => {
            this.$router.push("/newFiles");
          });
        } else {
          this.$router.push("/newFiles");
        }
      } else if (res.accountstatus == 400) {
        // 正常使用到期进入冻结期 只能浏览商城
        if (res.showmallbutton && res.showmsg !== "") {
          this.onlyGoMall(res);
        } else {
          this.$router.push("/newFiles");
        }
      } else if (res.accountstatus == 200) {
        // 正常使用
        console.log("当前用户状态:正常使用");

        this.$router.push("/newFiles");
      } else {
        if (res.showmallbutton && res.showmsg !== "") {
          loginDialogToMall(
            res.showmsg,
            this.$store.state.user.permissionArray,
            this
          );
        } else if (!res.showmallbutton && res.showmsg !== "") {
          commonDialog(res.showmsg, "确认", this, () => {
            this.$router.push("/newFiles");
          });
        } else {
          this.$router.push("/newFiles");
        }
      }
      if (res.isupbaseproductnotice) {
        this.$dialog.confirm({
          title: '提示',
          message: `已为您免费升级至专业版，谢谢您的支持与厚爱！`
        }).then(() => {
          this.$http.reqUpdateNotice({
            state: upBaseProductNotice
          }).then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                console.log('通知状态更新成功')
              } else {
                commonDialog(res.rltdesc, this);
              }
            } else {
              commonDialog(res.rtndesc, this);
            }
          });
        })
      }
    },
    // 分享进入
    sharelogin () {
      let obj = searchToObj(location.search);
      obj.tempuserguid = localStorage.getItem("userguid");
      console.log(obj);
      let newObj = {
        code: obj.code,
        state: obj.state,
        tempuserguid: obj.tempuserguid,
      };
      this.$http
        .reqPostWeixinRegLogin(newObj)
        .then((resp) => {
          console.log("微信注册成功====>", resp);
          this.bus.$emit("saveTokenHandle", resp, 1);
          console.log(
            "sessionStorage.getItem()",
           sessionStorage.getItem("userId")
          );
          this.$router.push(
            `/sharepage?docid=${obj.docid}&strdocid=${obj.strdocid}`
          );
        })
        .catch((err) => {
          console.log("微信注册======>", err);
        });
    },
    // 试用期满进入冻结期弹框
    onlyGoMall (res) {
      this.$dialog
        .confirm({
          title: "提示",
          message: res.showmsg,
          confirmButtonText: "在线商城",
          cancelButtonText: "退出登录",
        })
        .then(() => {
          if (this.$store.state.user.permissionArray.includes("900001")) {
            this.$router.push("onlineMall");
          }
        })
        .catch(() => {
          sessionStorage.clear();
          localStorage.removeItem('accoutName')
          localStorage.removeItem('accoutPwd')
          
          this.$cookie.delete("cookieObj");
          this.$store.commit("user/setUserId", "");
          this.$cookie.delete("cookieObjByWx");
          this.$router.push("/index");
        });
    },

    // 申请试用
    tryUseReg () {
      let newObj = {
        code: this.$route.query.code,
        state: this.$route.query.state,
        tempuserguid: localStorage.getItem("userguid"),
        fromagent: this.$route.query.agentcode, // 代理商信息
        fromdesc: "扫描代理商二维码注册",
        companyname: this.$route.query.companyname,
        username: this.$route.query.username,
        telno: this.$route.query.usertel,
        companyindustry: this.$route.query.industryname,
      };
      this.$http
        .reqPostWeixinRegLogin2(newObj)
        .then((resp) => {
          this.bus.$emit("saveTokenHandle", resp, 1);
          console.log(
            "sessionStorage.getItem()",
           sessionStorage.getItem("userId")
          );
          this.checkUserInfo(resp);
        })
        .catch((err) => {
          console.log("微信注册======>", err);
        });
    },
    // 立即购买
    goToBuy () {
      let newObj = {
        code: this.$route.query.code,
        state: this.$route.query.state,
        tempuserguid: localStorage.getItem("userguid"),
        fromagent: this.$route.query.agentcode,
        fromdesc: "扫描代理商二维码立即购买",
      };
      this.$http
        .reqPostWeixinRegLogin(newObj)
        .then((resp) => {
          this.bus.$emit("saveTokenHandle", resp, 1);
          console.log(
            "sessionStorage.getItem()",
           sessionStorage.getItem("userId")
          );
          this.$router.replace(
            `/onlineMall?agentcode=${this.$route.query.agentcode}`
          );
        })
        .catch((err) => {
          console.log("微信注册======>", err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-cell {
  border: 1px solid #ddd;
  margin-top: 20px;
  border-radius: 6px;
  min-height: 50px;
}
/deep/.van-cell:not(:last-child)::after {
  border-bottom: none;
}
/deep/.van-field__control {
  font-size: 12px;
}
</style>
